'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'house-chimney';
var width = 576;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = ['M80 202.9L80 448c0 26.5 21.5 48 48 48l80 0 0-168c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 168 80 0c26.5 0 48-21.5 48-48l0-245.1L384.3 104c-.1 0-.2 0-.3-.3l-96-85L80 202.9zM400 56l0 40.5 96 85L496 56c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8z', 'M282.7 2c3-2.7 7.6-2.7 10.6 0L384 82.3 384 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 139.7L573.3 250c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7L512 217.1 512 448c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-230.9L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM496 181.5L496 56c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 40.5 96 85zM384 103.7l-96-85L80 202.9 80 448c0 26.5 21.5 48 48 48l80 0 0-168c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 168 80 0c26.5 0 48-21.5 48-48l0-245.1L384.3 104l-.3 0 0-.3zM352 496l0-168c0-4.4-3.6-8-8-8l-112 0c-4.4 0-8 3.6-8 8l0 168 128 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;